export class SetChargingProfileModel {
    chargePointId:object;
    connectorId:number;
    chargingSessionId = 0;
}
